const baseUrls = {
  labsGatewayOrdersApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/orders-api/api`,
  labsGatewayLocationsApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/locations-api/api`,
  labsGatewayLabsCatalogApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/labscatalog-api/api`,
  labsGatewayUsersApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/users-api/api`,
  labsGatewayAssignationApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/assignation-api/api`,
  labsGatewayPapiApiBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/papi-web-api/api`,
  labsGatewayContentUploaderBaseUrl: `${process.env.REACT_APP_LABS_API_GATEWAY_BASE_URL}/contentuploader-api/api`,
  PharmacyGatewayOrdersApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_ORDERS_MICRO_SERVICE}/orders/api`,
  PharmacyGatewayUsersApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_ORDERS_MICRO_SERVICE}/users/api`,
  PharmacyGatewayPharmaciesApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_ORDERS_MICRO_SERVICE}/epharmacy/api`,
  PharmacyGatewayInventoryApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_ORDERS_MICRO_SERVICE}/inventory/api`,
  PharmacyGatewayPapiApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_ORDERS_MICRO_SERVICE}/papi-web/api`,
  PharmacyPatientsStaticBaseUrl: `${process.env.REACT_APP_PATIENTS_STATIC_URL}/api`,
};

const urls = {
  labsModuleUrls: {
    commonUrls: {
      getAllLabs: `${baseUrls.labsGatewayLocationsApiBaseUrl}/locations`,
      getUsers: `${baseUrls.labsGatewayUsersApiBaseUrl}/v2/users`,
      getLabsCatalog: `${baseUrls.labsGatewayLabsCatalogApiBaseUrl}/services`,
      searchLabsCatalog: `${baseUrls.labsGatewayLabsCatalogApiBaseUrl}/services/search`,
      uploadContent: `${baseUrls.labsGatewayContentUploaderBaseUrl}/content`,
    },
    accountManagementUrls: {
      authenticateUser: `${baseUrls.labsGatewayUsersApiBaseUrl}/login`,
      getLoginInfo: `${baseUrls.labsGatewayUsersApiBaseUrl}/users`,
    },
    ordersUrls: {
      getAllOrders: `${baseUrls.labsGatewayOrdersApiBaseUrl}/v2/orders`,
      getOrderDetails: `${baseUrls.labsGatewayOrdersApiBaseUrl}/orders`,
      getOrderPatientUserDetails: `${baseUrls.labsGatewayPapiApiBaseUrl}/user`,
      assignOrderToEntity: `${baseUrls.labsGatewayAssignationApiBaseUrl}/assignations`,
      updateOrderServices: `${baseUrls.labsGatewayOrdersApiBaseUrl}/orderitems`,
      updateOrderStatus: `${baseUrls.labsGatewayOrdersApiBaseUrl}/orderstates`,
      updateOrderNote: `${baseUrls.labsGatewayOrdersApiBaseUrl}/Orders`,
      scheduleOrder: `${baseUrls.labsGatewayOrdersApiBaseUrl}/v2/orders`,
      orderStateReasonsTree: `${baseUrls.labsGatewayOrdersApiBaseUrl}/orderstatereasonstree`,
    },
    laboratoriesUrls: {
      getlabsWithFilters: `${baseUrls.labsGatewayLocationsApiBaseUrl}/v2/locations`,
      addLab: `${baseUrls.labsGatewayLocationsApiBaseUrl}/locations`,
    },
    masterList: {
      getAllServices: `${baseUrls.labsGatewayLabsCatalogApiBaseUrl}/v2/services`,
      addService: `${baseUrls.labsGatewayLabsCatalogApiBaseUrl}/v2/services`,
      editService: `${baseUrls.labsGatewayLabsCatalogApiBaseUrl}/services`,
    },
  },
  pharmacyModuleUrls: {
    ordersUrls: {
      getAllOrders: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/v2/orders`,
      getOrderDetails: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/Orders`,
      getOrderPatientUserDetails: `${baseUrls.PharmacyGatewayPapiApiBaseUrl}/User/GetByUserKey`,
      getOrderStatusTypes: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/OrderStateTypes`,
      getPartnershipTypes: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/PartnershipTypes`,
      getOrderStateReasonsTree: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/OrderStateReasonsTree`,
      getProductStocksAllocation: `${baseUrls.PharmacyGatewayInventoryApiBaseUrl}/ProductBatches/StockAllocation`,
      updateOrderNote: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/Orders`,
      updateOrderStatus: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/OrderStates`,
      updateOrderItems: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/OrderItems`,
      updateShippingAddress: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/ShippingAddresses`,
      assignOrderToEntity: `${baseUrls.PharmacyGatewayOrdersApiBaseUrl}/AssignedEntities`,
    },
    commonUrls: {
      getUsers: `${baseUrls.PharmacyGatewayUsersApiBaseUrl}/v2/Users`,
      getPharmacies: `${baseUrls.PharmacyGatewayPharmaciesApiBaseUrl}/Pharmacies`,
      getServiceableAreas: `${baseUrls.PharmacyGatewayPharmaciesApiBaseUrl}/ServiceableAreas`,
      getProducts: `${baseUrls.PharmacyGatewayInventoryApiBaseUrl}/v2/ProductShapes`,
      getProductItems: `${baseUrls.PharmacyGatewayInventoryApiBaseUrl}/Products`,
      getInsuranceProviderByKey: `${baseUrls.PharmacyPatientsStaticBaseUrl}/insurance/GetInsuranceProviderById`,
    },
    accountManagementUrls: {
      authenticateUser: `${baseUrls.PharmacyGatewayUsersApiBaseUrl}/Logins`,
      getLoginInfo: `${baseUrls.PharmacyGatewayUsersApiBaseUrl}/Users`,
      getUserPermissions: `${baseUrls.PharmacyGatewayUsersApiBaseUrl}/Permissions`,
    },
    PharmaciesUrls: {
      getPharmacies: `${baseUrls.PharmacyGatewayPharmaciesApiBaseUrl}/v2/pharmacies`,
      registerPharmacy: `${baseUrls.PharmacyGatewayPharmaciesApiBaseUrl}/Pharmacies`,
      getPharmacyTypes: `${baseUrls.PharmacyGatewayPharmaciesApiBaseUrl}/PharmacyTypes`,
    },
  },
};

export default urls;
